import { IGetProfessionalCountsParams } from '../../types/IGetProfessionalCountsParams';

export const factoryGetProfessionalCountsKey = ({
  officeId,
  distance,
  state,
}: IGetProfessionalCountsParams) =>
  ['GET_PROFESSIONAL_COUNTS', officeId, distance, state] as const;
